var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.857,
    height: 28.39,
    viewBox: "0 0 29.857 28.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16165",
    "data-name": "Rectangle 16165",
    width: 29.857,
    height: 28.39,
    fill: "#f5d730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15460",
    "data-name": "Group 15460",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41223",
    "data-name": "Path 41223",
    d: "M14.931,0a1.2,1.2,0,0,1,1.124.7q1.9,3.863,3.816,7.722a.365.365,0,0,0,.314.232c1.577.222,3.153.453,4.729.681,1.305.189,2.611.371,3.915.569a1.2,1.2,0,0,1,.648,2.06c-.879.864-1.765,1.72-2.648,2.579q-1.813,1.764-3.628,3.526a.275.275,0,0,0-.092.277q.728,4.206,1.443,8.414a1.892,1.892,0,0,1,.01.735,1.186,1.186,0,0,1-1.721.751c-1-.516-2-1.043-2.992-1.566q-2.388-1.253-4.773-2.509a.289.289,0,0,0-.308.012Q10.936,26.2,7.1,28.206a1.212,1.212,0,0,1-1.7-.431,1.129,1.129,0,0,1-.141-.755q.444-2.6.891-5.2c.2-1.17.406-2.338.6-3.509a.342.342,0,0,0-.106-.248q-1.941-1.9-3.891-3.791C1.958,13.5,1.161,12.731.372,11.954a1.139,1.139,0,0,1-.3-1.234,1.157,1.157,0,0,1,.958-.814c.349-.063.7-.1,1.052-.155L7.932,8.9c.591-.086,1.182-.175,1.774-.252a.316.316,0,0,0,.273-.2Q11.886,4.575,13.8.705A1.205,1.205,0,0,1,14.931,0",
    transform: "translate(0)",
    fill: "#f5d730"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigStar);
export default __webpack_public_path__ + "static/media/big-star.638733a8f832550fad44594b99ef3f18.svg";
export { ForwardRef as ReactComponent };